import MasterService from "@/services/MasterService";

const state = {
  currencyData: {
    curr_id: "",
    curr_code: ""
  },
  globalOptions: []
};

const mutations = {
  SET_CURRENCY_DATA(state, currency) {
    state.currencyData = currency;
  },
  SET_GLOBAL_OPTIONS(state, options) {
    state.globalOptions = options;
  }
};

const actions = {
  fetchGlobalOptions: ({ commit }) => {
    MasterService.GetGlobalOptions().then(response => {
      const { data } = response;
      if (data && data.status && data.Records.length > 0) {
        const globalOptions = data.Records;
        commit("SET_GLOBAL_OPTIONS", globalOptions);

        let currCodeObj = data.Records.find(global_option_obj => {
          return global_option_obj.go_key == "CURRENCY";
        });

        const payload = {
          tableName: "ms_currencies",
          curr_is_active: "Y",
          curr_id: currCodeObj.go_value
        };

        MasterService.GetActiveList(payload)
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              const curr = data.Records[0];
              const currObj = {
                curr_id: curr.curr_id,
                curr_code: curr.curr_code
              };
              commit("SET_CURRENCY_DATA", currObj);
            } else {
              console.log("Currency fetch failed:", data.message);
            }
          })
          .catch(error => {
            console.log("Error in currency fetch:", error);
          });
      } else {
        console.log("Error fetching global options");
      }
    });
  }
};

const getters = {
  currencyCode: state => state.currencyData.curr_code,
  getGlobalOptions: state => state.globalOptions
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/MasterStore.js